import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============
    GetProgrammeCalendar(_data_) {
        return axios.post(config.WEB_API_PATH + 'AllMaster/v1/GetProgrammeCalendar', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    //======================================

    //============== Get API ===============
    GetCurrentUser(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetCurrentUser', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetProgAreaList(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetProgAreaList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetProgFinYear(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetProgFinYear', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetProgFinMonth(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetProgFinMonth', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/homeJS.js